import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertTriangle, Zap, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const LimitWarningModal = ({ 
  open, 
  onClose, 
  title = "Limit Reached",
  description,
  limitType,
  current,
  limit,
  planName
}) => {
  const getDefaultDescription = () => {
    switch (limitType) {
      case "team_members":
        return `You've reached the maximum number of team members (${current}/${limit}) allowed on your ${planName} plan.`;
      case "dedicated_lines":
        return `You've reached the maximum number of phone lines (${current}/${limit}) allowed on your ${planName} plan.`;
      case "sms":
        return `You've used all your SMS messages (${current}/${limit}) for this month on your ${planName} plan.`;
      case "minutes":
        return `You've used all your call minutes (${current}/${limit}) for this month on your ${planName} plan.`;
      default:
        return `You've reached a limit on your ${planName} plan.`;
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="glass-card border-white/10 sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-full bg-yellow-500/20 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-yellow-400" />
            </div>
            <DialogTitle className="text-white text-xl font-['Manrope']">
              {title}
            </DialogTitle>
          </div>
          <DialogDescription className="text-white/70 text-base">
            {description || getDefaultDescription()}
          </DialogDescription>
        </DialogHeader>

        <div className="bg-white/5 rounded-lg p-4 my-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-white/60">Current Plan</span>
            <span className="text-white font-medium">{planName}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-white/60">Usage</span>
            <span className="text-yellow-400 font-medium">{current} / {limit}</span>
          </div>
        </div>

        <DialogFooter className="flex flex-col sm:flex-row gap-3">
          <Button 
            variant="ghost" 
            onClick={onClose}
            className="text-white/70 hover:text-white hover:bg-white/10"
          >
            Maybe Later
          </Button>
          <Link to="/dashboard/settings" onClick={onClose}>
            <Button className="btn-primary w-full sm:w-auto">
              <Zap className="w-4 h-4 mr-2" />
              Upgrade Plan
              <ArrowUpRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LimitWarningModal;
